//#region Relevant Contact Table
export const columnList = [
    {field: 'fullName', header: 'Full Name', initialShown: true},
    {field: 'email', header: 'Email', initialShown: true},
    {field: 'description', header: 'Description', initialShown: true},
    {field: 'relationshipValue', header: 'Relationship', initialShown: true},
    {
        field: 'createdAt',
        header: 'Created At',
        initialShown: true,
        body: rowData => rowData.createdAt || 'N/A',
    },
    {
        header: 'Address Type',
        field: 'type',
        initialShown: false,
        body: rowData => rowData.type || 'N/A',
    },
    {
        header: 'Address',
        field: 'address',
        initialShown: false,
        body: rowData => rowData.address || 'N/A',
    },
    {
        header: 'Address Line 1',
        field: 'addressLine1',
        initialShown: false,
        body: rowData => rowData.addressLine1 || 'N/A',
    },
    {
        header: 'Address Line 2',
        field: 'addressLine2',
        initialShown: false,
        body: rowData => rowData.addressLine2 || 'N/A',
    },
    {
        header: 'Address Line 3',
        field: 'addressLine3',
        initialShown: false,
        body: rowData => rowData.addressLine3 || 'N/A',
    },
    {
        header: 'Address Line 4',
        field: 'addressLine4',
        initialShown: false,
        body: rowData => rowData.addressLine4 || 'N/A',
    },
    {
        header: 'City',
        field: 'city',
        initialShown: false,
        body: rowData => rowData.city || 'N/A',
    },
    {
        header: 'State',
        field: 'state',
        initialShown: false,
        body: rowData => rowData.state || 'N/A',
    },
    {
        header: 'Country',
        field: 'country',
        initialShown: false,
        body: rowData => rowData.country || 'N/A',
    },
    {
        header: 'Postal Code',
        field: 'postalCode',
        initialShown: false,
        body: rowData => rowData.postalCode || 'N/A',
    },
    {
        header: 'Phone',
        field: 'phone',
        initialShown: false,
        body: rowData => (rowData?.phone?.length > 9 ? rowData?.phone : 'N/A'),
    },
]
//#endregion
